import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';
import { IProductionSampleFilter } from '../models/filters/productionSampleFilter';
import { IProductionSampleForm } from '../models/forms/productionSampleForm';
import { IProductionSamplePDTO } from '../models/dtos/productionSamplePDTO';
import { API_CENTRE } from './config';

export default class ProductionSampleServices extends _o2sService {
   protected static override mainUrl:string = API_CENTRE + '/api/v1/ProductionSamples';
   protected static override getUrlFilter<F extends IProductionSampleFilter>(filter?: F): string {;
       let url = super.getUrlFilter(filter as IFilter);
       if (filter != null) 
       {
           if (filter.productionId != null)
               url += '&ProductionId=' + filter.productionId;
       }
       return url;
   }

   public static override toDTO(dic: IProductionSampleForm): IProductionSamplePDTO {
       const dto = super.toDTO(dic) as IProductionSamplePDTO;
       return dto;
   }

}
